import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'material-ui-snackbar-provider';

import { ContainedButton, OutlinedButton } from '../../Buttons';
import styles from './StartPreviewModal.module.scss';
import { User } from '../../OrganizationCard';
import Modal from '../../Modal';
import TrashButton from '../../TrashButton';
import { USER } from '../../../../enums';

type TDeleteUserModalProps = {
  isOpen: boolean;
  switchModal: () => void;
  user: USER;
  callback: () => void;
  handleQuickResolvedIssue: () => void;
};

const StartPreviewModal: React.FC<TDeleteUserModalProps> = ({ isOpen, switchModal, user, callback, handleQuickResolvedIssue }) => {
  const [loading, setLoading] = useState(false);
  const notification = useSnackbar();

  const onClose = () => {
    switchModal();
    setLoading(false);
  };

  const submit = async () => {
    try {
      setLoading(true);
      callback();
    } catch (err) {
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err.response.data.message);
      } else {
        console.log(err);
      }
    }
  };

  const handleResolved = async () => {
    try {
      setLoading(true);
      handleQuickResolvedIssue();
    } catch (err) {
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err.response.data.message);
      } else {
        console.log(err);
      }
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const [transformedHelpText, setTransformedHelpText] = useState('');

  useEffect(() => {
    if (user?.need_help?.length) {
      const result = user.need_help.replace(/\s*\([^)]*\)\s*$/, '');
      setTransformedHelpText(result);
    }
  }, [user?.need_help]);

  return (
    <Modal open={isOpen} onClose={!loading ? onClose : () => {}} loading={loading}>
      <div className={styles.modalBody}>
        <div className={styles.modalTitle}>
          <TrashButton className={styles.removeIcon} onClick={handleResolved} />
          <div className={styles.modalTop}>
            <div className={styles.titleText}>User requested help</div>
            <div className={styles.userInfo}>
              {user?.username} ({user.email}):
            </div>
            <div className={styles.descriptionBg}>{transformedHelpText}</div>
          </div>
        </div>
        <div className={styles.form}>
          <div className={styles.actionBtns}>
            <ContainedButton className={styles.containedButton} disabled={loading} onClick={submit}>
              <span>Go to account</span>
            </ContainedButton>

            <ContainedButton className={styles.resolveButton} disabled={loading} onClick={handleResolved}>
              <span>Resolve the issue</span>
            </ContainedButton>

            <OutlinedButton className={styles.outlinedButton} disabled={loading} kind="default" onClick={onClose}>
              <span>No, cancel</span>
            </OutlinedButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default StartPreviewModal;
